export const settingMap = {
  time: { title: '運動時間', unit: '分' },
  jogging: { title: 'ジョギング', unit: 'm' },
  crunch: { title: 'クランチ', unit: '回' },
  seiken: { title: '正拳突き', unit: '回' },
  squat: { title: 'スクワット', unit: '回' },
  'dumbbell-curl': { title: 'ダンベル(カール)', unit: '回' },
}



// WEBPACK FOOTER //
// ./src/components/data/Constants.js